import { createClient } from "@supabase/supabase-js";

function exigir(nome: "VITE_SUPABASE_URL" | "VITE_SUPABASE_PUBLISHABLE_KEY"): string {
  const valor = import.meta.env[nome];
  if (typeof valor !== "string" || valor.trim() === "") {
    throw new Error(`Configuração ausente: ${nome}. Veja apps/web/.env.example.`);
  }
  return valor.trim();
}

/** URL do projeto e chave publicável: ambas públicas; o acesso aos dados é controlado pelo RLS. */
export const supabaseUrl = exigir("VITE_SUPABASE_URL");
export const supabaseChavePublica = exigir("VITE_SUPABASE_PUBLISHABLE_KEY");

export const supabase = createClient(supabaseUrl, supabaseChavePublica);
